module.exports = __webpack_public_path__ + "img/myguard_about_05.687f7265.png";